// common
export const SET_EXPORTING = 'SET_EXPORTING'
export const SET_SEARCHING = 'SET_SEARCHING'

// machine
export const SET_MACHINE_LIST = 'SET_MACHINE_LIST'
export const SET_MACHINE_PAGETOTAL = 'SET_MACHINE_PAGETOTAL'
export const SET_MACHINE_QUERY = 'SET_MACHINE_QUERY'
export const SET_MACHINE_PAGE_NUM = 'SET_MACHINE_PAGE_NUM'
export const SET_MACHINE_PAGE_SIZE = 'SET_MACHINE_PAGE_SIZE'

// project
export const SET_PROJECT_LIST = 'SET_PROJECT_LIST'
export const SET_PROJECT_PAGETOTAL = 'SET_PROJECT_PAGETOTAL'
export const SET_PROJECT_QUERY = 'SET_PROJECT_QUERY'
export const SET_PROJECT_PAGE_NUM = 'SET_PROJECT_PAGE_NUM'
export const SET_PROJECT_PAGE_SIZE = 'SET_PROJECT_PAGE_SIZE'

// rent
export const SET_RENT_LIST = 'SET_RENT_LIST'
export const SET_RENT_PAGETOTAL = 'SET_RENT_PAGETOTAL'
export const SET_RENT_QUERY = 'SET_RENT_QUERY'
export const SET_RENT_PAGE_NUM = 'SET_RENT_PAGE_NUM'
export const SET_RENT_PAGE_SIZE = 'SET_RENT_PAGE_SIZE'
